<template>
  <div class="help-page">
    <UEditor v-model="content"></UEditor>

    <div class="submit">
      <Button @click="setHelp" size="large" type="primary">保存</Button>
    </div>
  </div>
</template>

<script>
import UEditor from "@/components/UEditor.vue";
export default {
  name: "Help",
  components: {
    UEditor
  },
  data() {
    return {
      content: ""
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      let data = await this.$http.get(`/api/help`);
      this.content = data.help_center;
    },
    setHelp() {
      this.$http
        .post(`/api/help`, {
          help_center: this.content
        })
        .then(() => {
          this.$Message.success("成功");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.help-page {
  padding: 10px;
}
.submit {
  margin-top: 20px;
  text-align: right;
}
</style>
